// AppContent.js - Contains the main app logic
import React, { useEffect, useState, useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Header from "./Components/Header.jsx";
import Sidebar from "./Components/Sidebar.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import Profile from "./pages/Profile.jsx";
import Progress from "./pages/Progress.jsx";
import "./App.css";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import DailyCourseModule from "./pages/courses/DailyCourseModule.jsx";
import DailyModule from "./pages/courses/DailyModule.jsx";
import AuthForm from "./pages/Auth/Auth.jsx";

import ForgotPassword from "./pages/Auth/ForgotPassword";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { StudentContext } from "./contexts/StudentContext";

function AppContent() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { studentData, setStudentData } = useContext(StudentContext);

  

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setLoading(true); // Set loading to true when auth state changes

      if (user) {
        try {
         
          const db = getFirestore();
          const studentRef = doc(db, "students", user.uid);
          const studentSnap = await getDoc(studentRef);

          if (studentSnap.exists()) {
            const userData = {
              uid: user.uid,
              id: user.uid,
              ...studentSnap.data(),
            };
            
            setStudentData(userData);
          } else {
            console.error("Student document not found for UID:", user.uid);
            setStudentData(null);
          }
        } catch (error) {
          console.error("Error fetching student data:", error);
          setStudentData(null);
        }
      } else {
        //console.log("User not authenticated");
        setStudentData(null);
      }

      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [setStudentData]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-light min-vh-100 d-flex">
      {user && <Sidebar studentData={studentData} />}
      <div
        className="flex-grow-1 d-flex flex-column"
        style={{ height: "100vh" }}
      >
        {user && <Header studentData={studentData} />}
        <main className="flex-grow-1 p-3 overflow-auto">
          <Routes>
            <Route
              path="/authentication"
              element={!user ? <AuthForm /> : <Navigate to="/" />}
            />
            <Route
              path="/forgot-password"
              element={!user ? <ForgotPassword /> : <Navigate to="/" />}
            />
            
            <Route
              path="/"
              element={user ? <Dashboard /> : <Navigate to="/authentication" />}
            />
            <Route
              path="/profile"
              element={
                user ? (
                  <Profile studentId={user.uid} />
                ) : (
                  <Navigate to="/authentication" />
                )
              }
            />
            <Route
              path="/progress"
              element={user ? <Progress /> : <Navigate to="/authentication" />}
            />
            <Route
              path="/dailycoursemodule"
              element={
                user ? <DailyCourseModule /> : <Navigate to="/authentication" />
              }
            />
            <Route
              path="/dailymodule"
              element={
                user ? <DailyModule /> : <Navigate to="/authentication" />
              }
            />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default AppContent;
